"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _activityIndicator = _interopRequireDefault(require("@gravity/activity-indicator"));
var _emptyState = _interopRequireDefault(require("@gravity/empty-state"));
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _skeleton = _interopRequireDefault(require("@gravity/skeleton"));
var _jsxFileName = "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/WidgetState/lib/WidgetState.js",
  _templateObject,
  _this = void 0;
function cov_1xsysv6qtl() {
  var path = "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/WidgetState/lib/WidgetState.js";
  var hash = "0e1bb6b03d11bee7928837306459bde5790dcad8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/WidgetState/lib/WidgetState.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 16
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 22,
          column: 20
        },
        end: {
          line: 41,
          column: 1
        }
      },
      "2": {
        start: {
          line: 23,
          column: 20
        },
        end: {
          line: 23,
          column: 39
        }
      },
      "3": {
        start: {
          line: 24,
          column: 18
        },
        end: {
          line: 24,
          column: 35
        }
      },
      "4": {
        start: {
          line: 25,
          column: 20
        },
        end: {
          line: 25,
          column: 37
        }
      },
      "5": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 27,
          column: 42
        }
      },
      "6": {
        start: {
          line: 27,
          column: 30
        },
        end: {
          line: 27,
          column: 42
        }
      },
      "7": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 40,
          column: 4
        }
      },
      "8": {
        start: {
          line: 43,
          column: 0
        },
        end: {
          line: 50,
          column: 2
        }
      },
      "9": {
        start: {
          line: 51,
          column: 0
        },
        end: {
          line: 55,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 20
          },
          end: {
            line: 22,
            column: 21
          }
        },
        loc: {
          start: {
            line: 22,
            column: 55
          },
          end: {
            line: 41,
            column: 1
          }
        },
        line: 22
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 20
          },
          end: {
            line: 25,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 20
          },
          end: {
            line: 25,
            column: 24
          }
        }, {
          start: {
            line: 25,
            column: 28
          },
          end: {
            line: 25,
            column: 37
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 42
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 27
      },
      "2": {
        loc: {
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 16
          }
        }, {
          start: {
            line: 27,
            column: 20
          },
          end: {
            line: 27,
            column: 28
          }
        }],
        line: 27
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 7
          },
          end: {
            line: 30,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 7
          },
          end: {
            line: 30,
            column: 16
          }
        }, {
          start: {
            line: 30,
            column: 20
          },
          end: {
            line: 30,
            column: 44
          }
        }, {
          start: {
            line: 30,
            column: 48
          },
          end: {
            line: 30,
            column: 69
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 31,
            column: 7
          },
          end: {
            line: 31,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 7
          },
          end: {
            line: 31,
            column: 16
          }
        }, {
          start: {
            line: 31,
            column: 20
          },
          end: {
            line: 31,
            column: 42
          }
        }, {
          start: {
            line: 31,
            column: 46
          },
          end: {
            line: 31,
            column: 58
          }
        }],
        line: 31
      },
      "5": {
        loc: {
          start: {
            line: 32,
            column: 7
          },
          end: {
            line: 38,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 7
          },
          end: {
            line: 32,
            column: 14
          }
        }, {
          start: {
            line: 33,
            column: 8
          },
          end: {
            line: 37,
            column: 10
          }
        }],
        line: 32
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0],
      "4": [0, 0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0e1bb6b03d11bee7928837306459bde5790dcad8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1xsysv6qtl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1xsysv6qtl();
var Wrapper = (cov_1xsysv6qtl().s[0]++, _styledComponents.default.div.attrs({
  className: 'stx-StateIndicator'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding: 2rem 0;\n  text-align: center;\n"]))));
/**
 * Use this compoment to display a loading icon or and error message in case of error
 */
cov_1xsysv6qtl().s[1]++;
var WidgetState = function WidgetState(_ref) {
  var state = _ref.state,
    code = _ref.code,
    themeQueries = _ref.themeQueries;
  cov_1xsysv6qtl().f[0]++;
  var isLoading = (cov_1xsysv6qtl().s[2]++, state === 'LOADING');
  var isError = (cov_1xsysv6qtl().s[3]++, state === 'ERROR');
  var errorCode = (cov_1xsysv6qtl().s[4]++, (cov_1xsysv6qtl().b[0][0]++, code) || (cov_1xsysv6qtl().b[0][1]++, 'DEFAULT'));
  // do not display anything if no state
  cov_1xsysv6qtl().s[5]++;
  if ((cov_1xsysv6qtl().b[2][0]++, !isLoading) && (cov_1xsysv6qtl().b[2][1]++, !isError)) {
    cov_1xsysv6qtl().b[1][0]++;
    cov_1xsysv6qtl().s[6]++;
    return null;
  } else {
    cov_1xsysv6qtl().b[1][1]++;
  }
  cov_1xsysv6qtl().s[7]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }, (cov_1xsysv6qtl().b[3][0]++, isLoading) && (cov_1xsysv6qtl().b[3][1]++, themeQueries.EQUILIBRIUM) && (cov_1xsysv6qtl().b[3][2]++, /*#__PURE__*/_react.default.createElement(_activityIndicator.default, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 49
    }
  })), (cov_1xsysv6qtl().b[4][0]++, isLoading) && (cov_1xsysv6qtl().b[4][1]++, themeQueries.EVOLUTION) && (cov_1xsysv6qtl().b[4][2]++, /*#__PURE__*/_react.default.createElement(_skeleton.default, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 47
    }
  })), (cov_1xsysv6qtl().b[5][0]++, isError) && (cov_1xsysv6qtl().b[5][1]++, /*#__PURE__*/_react.default.createElement(_emptyState.default, {
    media: /*#__PURE__*/_react.default.createElement(_icon.default, {
      size: 64,
      iconName: "error-outline",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 18
      }
    }),
    title: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: "gravity.WidgetState.errorTitle.".concat(errorCode),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 18
      }
    }),
    message: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: "gravity.WidgetState.errorMessage.".concat(errorCode),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 20
      }
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 9
    }
  })));
};
cov_1xsysv6qtl().s[8]++;
WidgetState.propTypes = {
  /** The state contains what state that should be displayed LOADING or ERROR value */
  state: _propTypes.default.oneOf(['ERROR', 'LOADING']),
  /** The code is the error code actually, it shows the message accordingly */
  code: _propTypes.default.oneOf(['DEFAULT', 'NOT_AUTHORIZED']),
  /** Theme context */
  themeQueries: _utils.WithThemeQueriesType
};
cov_1xsysv6qtl().s[9]++;
WidgetState.defaultProps = {
  state: null,
  code: null,
  themeQueries: {}
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(WidgetState));